import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { I18nPipe } from './shared/pipes/i18n.pipe';
import { CountryFlagApiPipe } from './shared/pipes/country-flag-api.pipe';
import { FreeTrialComponent } from './free-trial/free-trial.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatOption, MatSelect, MatSelectTrigger} from '@angular/material/select';


@NgModule({
  declarations: [
    AppComponent,
    I18nPipe,
    CountryFlagApiPipe,
    FreeTrialComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    MatSelect,
    MatSelectTrigger,
    MatOption
  ],
  providers: [
    I18nPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
